import { handleActions } from "redux-actions";
import { WORKING_ORDER_SHOW_INVENTORY_ARRIVING, WORKING_ORDER_HIDE_INVENTORY_ARRIVING } from "constants/action-types";

interface IInventoryState {
    productId?: string;
    originalIndex?: number;
    companyId?: string;
    warehouses?: string[];
}

const initialState: IInventoryState = {};

export const inventoryArriving = handleActions(
    {
        [WORKING_ORDER_SHOW_INVENTORY_ARRIVING]: (state, action: any) => action.payload,
        [WORKING_ORDER_HIDE_INVENTORY_ARRIVING]: () => ({}),
    },
    initialState,
);
